import { PAYPAL_REST_API } from 'modules/profile/payment-gateways/integrations/paypal-rest/api'
import { PaypalRestApiInterface } from 'modules/profile/payment-gateways/integrations/paypal-rest/types'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const usePaypalRestApi = () => {
  const { fetcher: connectFetcher } = useFetch<RequestMethodsEnum.post, PaypalRestApiInterface>({
    method: RequestMethodsEnum.post,
  })

  const { fetcher: confirmFetcher } = useFetch({
    method: RequestMethodsEnum.post,
  })

  const { fetcher: deleteFetcher } = useFetch({
    method: RequestMethodsEnum.delete,
  })

  return {
    connect: (redirectLink: string) =>
      connectFetcher(`${PAYPAL_REST_API}/connect`, {
        redirectLink,
      }),
    confirmConnect: (body: object) => confirmFetcher(`${PAYPAL_REST_API}/connect/confirm`, body),
    disconnect: () => deleteFetcher(`${PAYPAL_REST_API}/disconnect`),
  }
}
